import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { S3_ASSETS_PATH } from '../../../../constants';
import { sortMnoList } from '../../../../utils';
import { CustomTooltip } from '../../../../shared_elements';
import RemoveMnoModal from './RemoveMnoModal';
import { Box, BoxV2, Button, usePermission } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

export default function MnoStatusTableNew(props) {
  const {
    campaignUid,
    mnoStatusInfo,
    electedDcas,
    excludedMnos = [],
    isCnp = false,
    onRemoveMno,
  } = props;
  const [openRemoveMnoModal, setOpenRemoveMnoModal] = useState(false);
  const [selectedMno, setSelectedMno] = useState();
  const { hasPermission } = usePermission();

  return (
    <div
      className="mno-overview custom-scrollbar"
      data-testid="mnoStatusTableNew"
    >
      <ul className="mno-listing list-unstyled">
        {mnoStatusInfo
          ? sortMnoList(mnoStatusInfo, ['rulesEngineResultsJson', 'mno']).map(
              (item, index) =>
                item.rulesEngineResultsJson &&
                item.rulesEngineResultsJson.qualify &&
                item.rulesEngineResultsJson.mnoSupport ? (
                  <li key={index}>
                    <Grid container>
                      <Grid
                        item
                        xs={2}
                        className="name"
                        style={{ maxWidth: `11%` }}
                        data-testid="mnoStatusTableNewMno"
                      >
                        {item.rulesEngineResultsJson
                          ? item.rulesEngineResultsJson.mno
                          : '--'}
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '10%' }}
                        className="text-center"
                        data-testid="mnoStatusTableExcluded"
                      >
                        <h3 className="paragraph bold">
                          <Box
                            flexDirection="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <span>EXCLUDED</span>
                          </Box>
                        </h3>
                        <p className="paragraph bold">
                          {excludedMnos.includes(item.networkId) ? 'Yes' : 'No'}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '10%' }}
                        className="text-center"
                        data-testid="mnoStatusTableNewQualify"
                      >
                        <h3 className="paragraph bold">
                          <Box
                            flexDirection="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <span>QUALIFY</span>
                          </Box>
                        </h3>
                        <p className="paragraph bold">
                          {item.rulesEngineResultsJson ? (
                            item.rulesEngineResultsJson.qualify ? (
                              'Yes'
                            ) : (
                              <img
                                style={{ position: 'relative', bottom: '5px' }}
                                src={`${S3_ASSETS_PATH}/images/not-qualify.svg`}
                              />
                            )
                          ) : (
                            '--'
                          )}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '10%' }}
                        data-testid="mnoStatusTableNewMnoReview"
                      >
                        <h3 className="paragraph bold">
                          <Box
                            flexDirection="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <span>MNO REVIEW</span>
                          </Box>
                        </h3>
                        <p className="paragraph bold">
                          {item.rulesEngineResultsJson
                            ? item.rulesEngineResultsJson.mnoReview
                              ? 'Yes'
                              : 'No'
                            : 'N/A'}
                        </p>
                      </Grid>
                      {item.rulesEngineResultsJson.mno == 'T-Mobile' ? (
                        <>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '9%' }}
                            data-testid="mnoStatusTableNewBandTier"
                          >
                            <h3
                              className="paragraph bold"
                              style={{ marginLeft: 5 }}
                            >
                              BRAND
                              <br />
                              TIER
                            </h3>
                            {item.rulesEngineResultsJson.mno == 'T-Mobile' &&
                            item.rulesEngineResultsJson.brandTier ? (
                              <CustomTooltip
                                arrow
                                title={`Please check the Knowledge Base for the ”Daily and Monthly maximum throughput values per Brand” associated with this tier.`}
                                placement="top"
                              >
                                <p
                                  className="paragraph light"
                                  style={{ marginLeft: 5 }}
                                >
                                  {item.rulesEngineResultsJson.brandTier}
                                </p>
                              </CustomTooltip>
                            ) : (
                              <p
                                className="paragraph light"
                                style={{ marginLeft: 5 }}
                              >
                                {item.rulesEngineResultsJson.tpm
                                  ? item.rulesEngineResultsJson.tpm
                                  : 'N/A'}
                              </p>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '11%' }}
                            data-testid="mnoStatusTableNewBrandDailyCap"
                          >
                            <h3 className="paragraph bold">
                              BRAND
                              <br />
                              DAILY CAP
                            </h3>
                            {item.rulesEngineResultsJson.mno == 'T-Mobile' ? (
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.brandDailyCap
                                  ? item.rulesEngineResultsJson.brandDailyCap
                                  : item.rulesEngineResultsJson.brandTier &&
                                    item.rulesEngineResultsJson.brandTier ===
                                      'UNCAPPED'
                                  ? 'No'
                                  : 'N/A'}
                              </p>
                            ) : (
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.tpmScope
                                  ? item.rulesEngineResultsJson.tpmScope
                                  : 'N/A'}
                              </p>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '6%' }}
                            data-testid="mnoStatusTableNewMmsTpm"
                          >
                            <h3 className="paragraph bold">
                              MMS
                              <br />
                              TPM
                            </h3>
                            {item.rulesEngineResultsJson.mno == 'T-Mobile' &&
                            item.rulesEngineResultsJson.brandTier ? (
                              <CustomTooltip
                                arrow
                                title={`Please check the Knowledge Base for the ”Daily and Monthly maximum throughput values per Brand” associated with this tier.`}
                                placement="top"
                              >
                                <p className="paragraph light">
                                  {item.rulesEngineResultsJson.mmsTpm
                                    ? item.rulesEngineResultsJson.mmsTpm
                                    : 'N/A'}
                                </p>
                              </CustomTooltip>
                            ) : (
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.mmsTpm
                                  ? item.rulesEngineResultsJson.mmsTpm
                                  : 'N/A'}
                              </p>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '9%' }}
                            data-testid="mnoStatusTableNewTpmScope"
                          >
                            <h3
                              className="paragraph bold"
                              style={{ marginLeft: 5 }}
                            >
                              TPM
                              <br />
                              SCOPE
                            </h3>
                            {
                              <p
                                className="paragraph light"
                                style={{ marginLeft: 5 }}
                              >
                                {item.rulesEngineResultsJson.tpmScope
                                  ? item.rulesEngineResultsJson.tpmScope
                                  : 'N/A'}
                              </p>
                            }
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '11%' }}
                            data-testid="mnoStatusTableNewSmsTpm"
                          >
                            <h3 className="paragraph bold">
                              SMS
                              <br />
                              TPM
                            </h3>
                            {item.rulesEngineResultsJson.mno == 'AT&T' ? (
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.tpm
                                  ? item.rulesEngineResultsJson.tpm
                                  : 'N/A'}
                              </p>
                            ) : (
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.tpm
                                  ? item.rulesEngineResultsJson.tpm
                                  : 'N/A'}
                              </p>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            style={{ maxWidth: '6%' }}
                            data-testid="mnoStatusTableNewMmsTpm"
                          >
                            <h3 className="paragraph bold">
                              MMS
                              <br />
                              TPM
                            </h3>
                            {
                              <p className="paragraph light">
                                {item.rulesEngineResultsJson.mmsTpm
                                  ? item.rulesEngineResultsJson.mmsTpm
                                  : 'N/A'}
                              </p>
                            }
                          </Grid>
                        </>
                      )}

                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '10%' }}
                        data-testid="mnoStatusTableNewMessageClass"
                      >
                        <h3 className="paragraph bold">
                          MESSAGE
                          <br />
                          CLASS
                        </h3>
                        <p className="paragraph light">
                          {item.rulesEngineResultsJson
                            ? item.rulesEngineResultsJson.msgClass
                              ? item.rulesEngineResultsJson.msgClass
                              : 'N/A'
                            : 'N/A'}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '12%' }}
                        data-testid="mnoStatusTableNewStatus"
                      >
                        <h3 className="paragraph bold">STATUS</h3>
                        <p className="paragraph bold status">
                          <img
                            src={`${S3_ASSETS_PATH}/images/${item.status.toLowerCase()}-icon.svg`}
                            alt=""
                          />
                          <span>
                            {item.status.toLowerCase() === 'approved'
                              ? 'REGISTERED'
                              : item.status}
                          </span>
                          {item.status.toLowerCase() === 'suspended' && (
                            <CustomTooltip
                              arrow
                              title={`Suspended by ${item.statusIssuerRole}`}
                              placement="bottom-end"
                            >
                              <BoxV2
                                as="span"
                                sx={{
                                  ml: 'xxs',
                                  color: '#0091B3 !important',
                                  fontWeight: 400,
                                  fontSize: 'H300',
                                }}
                              >
                                <FontAwesomeIcon icon={faInfoCircle} />
                              </BoxV2>
                            </CustomTooltip>
                          )}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ maxWidth: '11%' }}
                        data-testid="mnoStatusTableNewElectedDca"
                      >
                        {!isCnp &&
                        hasPermission('campaignDetail.deleteNetwork') &&
                        excludedMnos.includes(item.networkId) ? (
                          <>
                            <h3
                              className="paragraph bold"
                              style={{ padding: '20px 0px 17px' }}
                            >
                              ACTION
                            </h3>
                            <p className="paragraph light">
                              <Button
                                color="secondary"
                                shape="square"
                                size="small"
                                style={{
                                  margin: '-3px auto 0',
                                  borderRadius: '4px',
                                  height: '24px',
                                  padding: '8px',
                                  fontSize: '12px',
                                }}
                                onClick={() => {
                                  setOpenRemoveMnoModal(true);
                                  setSelectedMno({
                                    id: item.networkId,
                                    name: item.rulesEngineResultsJson.mno,
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </p>
                          </>
                        ) : (
                          <>
                            <h3
                              className="paragraph bold"
                              style={{ padding: '20px 0px 17px' }}
                            >
                              ELECTED DCA
                            </h3>
                            <p className="paragraph light">
                              {electedDcas.includes(item.networkId)
                                ? 'Yes'
                                : 'No'}
                            </p>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </li>
                ) : null
            )
          : null}
      </ul>

      {selectedMno && (
        <RemoveMnoModal
          open={openRemoveMnoModal}
          mno={selectedMno}
          campaignUid={campaignUid}
          onClose={() => {
            setOpenRemoveMnoModal(false);
            setSelectedMno(undefined);
          }}
          onComplete={() => {
            onRemoveMno(selectedMno);
          }}
        />
      )}
    </div>
  );
}
